import { useMemo } from 'react';
import type { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createAppTheme } from '../theme';
import { usePortalBranding } from './PortalContext';

/**
 * Cấp theme MUI dựng theo màu thương hiệu của cổng truy cập hiện tại.
 *
 * PHẢI nằm BÊN TRONG PortalProvider — nó đọc branding từ context đó.
 *
 * Branding tải bất đồng bộ nên lượt render đầu luôn là màu mặc định, rồi đổi
 * sang màu cổng khi API trả về. Chấp nhận cái nháy màu rất ngắn này thay vì
 * chặn render chờ branding — chặn thì người dùng phải nhìn màn trắng lâu hơn.
 */
export function BrandThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  const { branding } = usePortalBranding();
  const theme = useMemo(() => createAppTheme(branding?.brand_color), [branding?.brand_color]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
